export default __webpack_public_path__ + "static/media/2.1f0665c5.jpg";